"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sredProjectCategoryLabel = exports.SelectedSredProjectCategory = void 0;
var SelectedSredProjectCategory;
(function (SelectedSredProjectCategory) {
    SelectedSredProjectCategory["SRED_CREDIT"] = "SRED_CREDIT";
    SelectedSredProjectCategory["NOT_STARTED_OR_NONE"] = "NOT_STARTED_OR_NONE";
})(SelectedSredProjectCategory || (exports.SelectedSredProjectCategory = SelectedSredProjectCategory = {}));
exports.sredProjectCategoryLabel = {
    [SelectedSredProjectCategory.SRED_CREDIT]: 'SR&ED Credit',
    [SelectedSredProjectCategory.NOT_STARTED_OR_NONE]: 'Not Started / None',
};
